import { useMutation } from "react-query"
import api from "../../client"
import { queryClient, queryKeys } from "../../query"
import { UpdateOrderTemplatePayload, UpdateOrderTemplateResponseData } from "../../types/order-template"

const putData = async (uuid: string | undefined, payload: UpdateOrderTemplatePayload)
    : Promise<UpdateOrderTemplateResponseData> => {
    try {
        const { data } = await api.put<UpdateOrderTemplateResponseData>(
            `/order-templates/${uuid}`,
            payload
        )

        queryClient.invalidateQueries(queryKeys.ORDER_TEMPLATE(uuid))
        queryClient.invalidateQueries(["order-templates"], { refetchInactive: true })

        return data
    } catch ({ response: { data } }) {
        return data as UpdateOrderTemplateResponseData
    }
}

export const useOrderTemplateUpdate = (uuid: string | undefined) => {
    return useMutation((payload: UpdateOrderTemplatePayload) => {
        return putData(uuid, payload)
    })
}
